import './polyfills';
import '@fontsource/roboto/index.css';
import '@fontsource/barlow/index.css';
import '@/index.css';
import { toAppUrl } from './app/core/utils';
import history from './app/core/history';
import { getSignInMountPath } from './app/core/auth';
import { RootApp } from './RootApp';
import { mainTheme } from './mainTheme';
import { ServerConfig, axiosProvider } from '@/app/core/axios';
import { Spinner } from '@/app/core/components/spinner/Spinner';
import axios from 'axios';
import { Spin } from 'antd';
import { ColorModeScript, CSSReset, ChakraProvider } from '@chakra-ui/react';
import { trimExtraSlashesInUri } from '@ssar-app/okta-authn-react';
import { render } from 'react-dom';
import { Router } from 'react-router';
import { AppFeaturesConfig } from '@ssar-app/domain';
import { theme } from '@ssar-app/uikit/src/theme';

const getAppFeaturesConfig = async () => {
  return axios
    .get<AppFeaturesConfig>(toAppUrl('/config/app-config'))
    .then((res) => res.data);
};
import { Spin as ChakraSpin } from '@ssar-app/uikit';

const getApiConfig = async () => {
  return axios
    .get<ServerConfig>(toAppUrl('/api-config'))
    .then((res) => res.data);
};

export const renderApp = async () => {
  Spin.setDefaultIndicator(<Spinner />);
  ChakraSpin.setDefaultIndicator(<Spinner containerStyles={{ margin: 0 }} />);
  await Promise.all([getAppFeaturesConfig(), getApiConfig()])
    .then(([appConfig, serverConfig]) => {
      axiosProvider.setApiConfig(serverConfig.apiConfig);
      axiosProvider.setAuthDeniedHandlers({
        onAuthenticationError() {
          const path = trimExtraSlashesInUri(`/${getSignInMountPath()}`);

          history.push(path, {
            message: 'Session is invalid/expired.',
          });
        },
        onAuthorizationError() {
          history.push('/access-denied', {
            message: 'Access denied.',
          });
        },
      });
      const renderFn = () => {
        render(
          <>
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />
            <ChakraProvider theme={mainTheme}>
              <Router history={history}>
                <RootApp appConfig={appConfig}></RootApp>
              </Router>
              <CSSReset />
            </ChakraProvider>
          </>,
          document.getElementById('root'),
        );
      };
      renderFn();
    })
    .catch((err) => {
      console.error(err);
    });
};
